import { useAuth, homeForRole } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { Loader } from "@/components/common";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) return <Loader label="Vérification de la session..." />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeForRole(user.role)} replace />;
  return children;
}
